import { render, staticRenderFns } from "./TerminalSelectorPlugin.vue?vue&type=template&id=23e04bbc&scoped=true"
import script from "./TerminalSelectorPlugin.vue?vue&type=script&lang=js"
export * from "./TerminalSelectorPlugin.vue?vue&type=script&lang=js"
import style0 from "./TerminalSelectorPlugin.vue?vue&type=style&index=0&id=23e04bbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e04bbc",
  null
  
)

export default component.exports